import { render, staticRenderFns } from "./SettingsTemplatesLanding.vue?vue&type=template&id=18b2acd2&scoped=true"
import script from "./SettingsTemplatesLanding.vue?vue&type=script&lang=js"
export * from "./SettingsTemplatesLanding.vue?vue&type=script&lang=js"
import style0 from "./SettingsTemplatesLanding.vue?vue&type=style&index=0&id=18b2acd2&prod&lang=scss&scoped=true"
import style1 from "./SettingsTemplatesLanding.vue?vue&type=style&index=1&id=18b2acd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2acd2",
  null
  
)

export default component.exports